import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';
import { BrokerFormValues } from './BrokerFormValues';
import { BrokerFormFieldNames } from './BrokerFormFieldNames';
import { addressValidationRules } from 'features/new-actor/form/validation-rules/addressValidationRules';

import { gerantValidationRules, optionalCompanyPhoneRule } from 'back-office/shared/components/gerant/gerantFields';
export const brokerValidationRules: ValidationRules<keyof BrokerFormValues> = {
  ...gerantValidationRules,
  ...addressValidationRules,
  [BrokerFormFieldNames.CompanyName]: Yup.string()
    .required('La raison sociale est requise')
    .min(2, 'La raison sociale doit contenir au moins 2 caractères'),
  [BrokerFormFieldNames.Phone]: optionalCompanyPhoneRule,
  [BrokerFormFieldNames.ComplaintEmail]: Yup.string()
    .required("L'email de réclamation est requis")
    .email('Format email invalide'),
  [BrokerFormFieldNames.RegistrationNumber]: Yup.string()
    .required('Le numéro SIRET est requis')
    .matches(/^\d{14}$/, 'Le SIRET doit contenir 14 chiffres'),
  [BrokerFormFieldNames.Capital]: Yup.number()
    .typeError('Le capital doit être un nombre')
    .required('Le capital est requis')
    .min(0, 'Le capital doit être positif'),
  [BrokerFormFieldNames.RcsCity]: Yup.string()
    .required('La ville RCS est requise'),
  [BrokerFormFieldNames.RcsNumber]: Yup.string()
    .required('Le numéro RCS est requis'),
  // Aligné sur le pipeline back (OriasRequis pour la nature Courtier) : sans
  // cette règle, l'échec ne remontait qu'après la soumission côté serveur.
  [BrokerFormFieldNames.OriasNumber]: Yup.string()
    .required("Le numéro ORIAS est requis pour un cabinet de courtage"),
  [BrokerFormFieldNames.Rcp]: Yup.string()
    .nullable()
    .notRequired(),
  [BrokerFormFieldNames.SousNature]: Yup.string()
    .oneOf(['CLASSIQUE', 'GRO'], 'Type de cabinet invalide')
    .required('Le type de cabinet est requis'),
  [BrokerFormFieldNames.FirstName]: Yup.string()
    .required('Le prénom est requis')
    .min(2, 'Le prénom doit contenir au moins 2 caractères'),
  [BrokerFormFieldNames.LastName]: Yup.string()
    .required('Le nom est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères'),
  [BrokerFormFieldNames.Email]: Yup.string()
    .required("L'email est requis")
    .email('Format email invalide'),
  [BrokerFormFieldNames.PlateformeIds]: Yup.array()
    .of(Yup.string().required()),
  [BrokerFormFieldNames.RoleIds]: Yup.array()
    .of(Yup.string().required()),
  [BrokerFormFieldNames.IsActive]: Yup.boolean(),
  [BrokerFormFieldNames.Email]: Yup.string()
    .required("L'email est requis")
    .email('Format email invalide'),
  [BrokerFormFieldNames.Username]: Yup.string()
    .required("Le nom d'utilisateur est requis")
    .min(3, "Le nom d'utilisateur doit contenir au moins 3 caractères"),
  [BrokerFormFieldNames.Password]: Yup.string()
    .required('Le mot de passe est requis')
    .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
  // Collaborateurs additionnels : section optionnelle, mais chaque ligne
  // ajoutée doit être complète
  [BrokerFormFieldNames.Collaborators]: Yup.array().of(
    Yup.object({
      firstName: Yup.string().required('Le prénom est requis'),
      lastName: Yup.string().required('Le nom est requis'),
      email: Yup.string().required("L'email est requis").email('Format email invalide'),
      isOwner: Yup.boolean().required(),
    }),
  ),
};
